<template>
    <InscriptionsList :estados="['PAGO_REALIZADO', 'PAGO_BONIFICADO', 'pago_no_paga']" />
  </template>
  
  <script>
  import InscriptionsList from '../components/inscriptions-list.vue';
  
  export default {
    components: {
      InscriptionsList
    }
  }
  </script>